import React from 'react';
import '../../../style/transformerTariffs.scss';
import LandrateInput from './components/LandrateInput';
import Paper from '@material-ui/core/Paper';
import firebaseApp from '../../../services/firebaseService';
import generalFunctions from '../../../store/general/functions';
import TariffHelper, { ILPUTariff } from '../../../@types/model/transformer/tariffs/tariffs';
import { Formik, FieldArray } from 'formik';
import { connect } from 'react-redux';
import { IRootState, IAuthState } from '../../../@types/redux';
import StadiumButton from '../../customComponents/button/StadiumButton';
import OutlinedStadiumButton from '../../customComponents/button/OutlinedStadiumButton';
import AbsoluteLinearProgress from '../../customComponents/progress/AbsoluteLinearProgress';
import DateMillisInput from '../../customComponents/form/DateMillisInput';
import FirebaseHelper from '../../../services/helper/firebaseHelper';

interface ILPUEditProps {
    auth : IAuthState;

    lpu : ILPUTariff;
    vat : number;
    onSaved : () => void;
    enabled : boolean;
    disabledStartDate : boolean;
}

const LPUEdit = (props : ILPUEditProps) : React.ReactElement => {

    const save = async (values : ILPUTariff) : Promise<void> => {
        if (!props.auth.session || !props.enabled) return;
        const currentLpu = { ...values };

        try {
            currentLpu.vat = props.vat;

            // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
            if (!currentLpu.ref) {
                currentLpu.ref = TariffHelper.lpuDoc();
                currentLpu.createdBy = firebaseApp.firestore().collection('employee').doc(props.auth.session.firebaseUser.uid);
                currentLpu.createdByEmployee = props.auth.session.employee.EmployeeNumber ?? '';
                currentLpu.createdByName = props.auth.session.employee.Name;
                currentLpu.createdOn = FirebaseHelper.timestampNow();
            }

            currentLpu.updatedBy = firebaseApp.firestore().collection('employee').doc(props.auth.session.firebaseUser.uid);
            currentLpu.updatedByEmployee = props.auth.session.employee.EmployeeNumber ?? '';
            currentLpu.updatedByName = props.auth.session.employee.Name;
            currentLpu.updatedOn = FirebaseHelper.timestampNow();

            await TariffHelper.saveLPU(currentLpu);
            props.onSaved();
        } catch (ex) {
            generalFunctions.generalShowError(ex, 'Error saving LPU Tariff');
            throw ex;
        }
    };

    return (
        <div className='fdc flx1 ais pr20 pl20 pt10 pb20 transformer-tariffs lpu oya'>
            <Formik
                enableReinitialize
                initialValues={props.lpu}
                onSubmit={save}
            >
                {({
                    values,
                    handleChange,
                    handleBlur,
                    handleSubmit,
                    handleReset,
                    isSubmitting,
                }) => (
                    <form id='lpu-form' className='' onSubmit={handleSubmit} onReset={handleReset}>
                        <div className='fdr aife pb10'>
                            <DateMillisInput name='startDate' label='Start Date' className='' disabled={isSubmitting || !props.enabled || props.disabledStartDate} />
                            {
                                !!props.lpu.endDate &&
                                    <DateMillisInput name='endDate' label='End Date' className='ml20' disabled />
                            }
                            <div className='fdr jcfe wfill mb5 fsi'>
                                <span>Note: All tariffs should be entered exclusive of VAT.</span>
                            </div>
                        </div>
                        <Paper className='fdc ais mb10' elevation={3}>
                            <div className='fdr ais'>
                                <div className='fdc ais flx2'>
                                    <div className='fdr flx1'/>
                                    <div className='fdr flx2'>
                                        <div className='fdr flx1 aic jcc transmission-zone'>
                                                Transmission zone
                                        </div>
                                        <div className='fdr flx1 aic jcc voltage'>
                                                Voltage
                                        </div>
                                    </div>
                                </div>
                                <div className='fdc ais flx5'>
                                    <div className='fdc flx1 ais jcc average'>
                                            Active Energy Charge [c/kWh]
                                    </div>
                                    <div className='fdr flx1 ais jcc'>
                                        <div className='fdr flx1 aic jcc high-header'>
                                            <span>High Demand Season</span>&nbsp;[Jun - Aug]
                                        </div>
                                        <div className='fdr flx1 aic jcc low-header'>
                                            <span>Low Demand Season </span>&nbsp;[Sep - May]
                                        </div>
                                    </div>
                                    <div className='fdr flx1 ais jcc'>
                                        <div className='fdr flx1 ais'>
                                            <div className='fdc flx1 ais pt5 pb5 high peak'>
                                                <span className='flx1 aic jcc'>
                                                        Peak
                                                </span>
                                            </div>
                                            <div className='fdc flx1 ais pt5 pb5 high standard'>
                                                <span className='flx1 aic jcc'>
                                                        Standard
                                                </span>
                                            </div>
                                            <div className='fdc flx1 ais pt5 pb5 high off-peak'>
                                                <span className='flx1 aic jcc'>
                                                        Off Peak
                                                </span>
                                            </div>
                                        </div>
                                        <div className='fdr flx1 ais'>
                                            <div className='fdc flx1 ais pt5 pb5 low peak'>
                                                <span className='flx1 aic jcc'>
                                                        Peak
                                                </span>
                                            </div>
                                            <div className='fdc flx1 ais pt5 pb5 low standard'>
                                                <span className='flx1 aic jcc'>
                                                        Standard
                                                </span>
                                            </div>
                                            <div className='fdc flx1 ais pt5 pb5 low off-peak'>
                                                <span className='flx1 aic jcc'>
                                                        Off Peak
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className='fdr flx3'>
                                    <div className='fdc flx1'>
                                        <div className='flx1'/>
                                        <div className='flx2'>
                                            <span className='flx2 aic jcc legacy-charge'>
                                                    Legacy Charge [c/kWh]
                                            </span>
                                        </div>
                                    </div>
                                    <div className='fdc flx1'>
                                        <div className='flx1'/>
                                        <div className='flx2'>
                                            <span className='flx2 aic jcc generation-capacity-charge  '>
                                                    Generation Capacity Charge [R/kVa/m]
                                            </span>
                                        </div>
                                    </div>
                                    <div className='fdc flx1'>
                                        <div className='flx1'/>
                                        <div className='flx2'>
                                            <span className='flx2 aic jcc network-capacity'>
                                                    Network Capacity Charges [R/kVA/m]
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {
                                isSubmitting &&
                                    <div className='fdc ais wfill submitting'>
                                        <AbsoluteLinearProgress />
                                    </div>
                            }
                            <div className='fdc ais flx2 pb5'>
                                <FieldArray
                                    name='zones'
                                    render={
                                        () => (
                                            <div className='fdc ais'>
                                                {
                                                    values.zones.map((zone, index) => (
                                                        <div className='fdr tariff-row mnh65' key={`zone_${zone.lower}_${zone.upper}`}>
                                                            <div className='fdc flx2'>
                                                                <div className='fdr flx1'>
                                                                    <div className='fdc flx1 aic jcc zone-cell'>
                                                                        {
                                                                            !!zone.lower &&
                                                                                <span>&gt; {zone.lower} KM{!zone.upper ? '' : ' &'}</span>
                                                                        }
                                                                        {
                                                                            !!zone.upper &&
                                                                                <span>&le; {zone.upper} KM</span>
                                                                        }
                                                                    </div>
                                                                    <div className='fdc flx1 aife jcc voltage-cell'>
                                                                        <span className='pb10 pr10'>&lt; 500V</span>
                                                                        <span className='pr10'>&ge; 500V &amp; &le; 22KV</span>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className='fdr flx5 data-columns'>
                                                                <div className='fdc flx1 aic jcc'>
                                                                    <div className='fdr pb10'>
                                                                        <LandrateInput 
                                                                            value={zone.highDemand.peak[0]}
                                                                            disabled={isSubmitting || !props.enabled}
                                                                            name={`zones.${index}.highDemand.peak[0]`}
                                                                            onChange={handleChange}
                                                                            onBlur={handleBlur} />
                                                                    </div>
                                                                    <div className='fdr'>
                                                                        <LandrateInput 
                                                                            value={zone.highDemand.peak[1]}
                                                                            disabled={isSubmitting || !props.enabled}
                                                                            name={`zones.${index}.highDemand.peak[1]`}
                                                                            onChange={handleChange}
                                                                            onBlur={handleBlur} />
                                                                    </div>
                                                                </div>
                                                                <div className='fdc flx1 aic jcc'>
                                                                    <div className='fdr pb10'>
                                                                        <LandrateInput 
                                                                            value={zone.highDemand.standard[0]}
                                                                            disabled={isSubmitting || !props.enabled}
                                                                            name={`zones.${index}.highDemand.standard[0]`}
                                                                            onChange={handleChange}
                                                                            onBlur={handleBlur} />
                                                                    </div>
                                                                    <div className='fdr'>
                                                                        <LandrateInput 
                                                                            value={zone.highDemand.standard[1]}
                                                                            disabled={isSubmitting || !props.enabled}
                                                                            name={`zones.${index}.highDemand.standard[1]`}
                                                                            onChange={handleChange}
                                                                            onBlur={handleBlur} />
                                                                    </div>
                                                                </div>
                                                                <div className='fdc flx1 aic jcc'>
                                                                    <div className='fdr pb10'>
                                                                        <LandrateInput 
                                                                            value={zone.highDemand.offPeak[0]}
                                                                            disabled={isSubmitting || !props.enabled}
                                                                            name={`zones.${index}.highDemand.offPeak[0]`}
                                                                            onChange={handleChange}
                                                                            onBlur={handleBlur} />
                                                                    </div>
                                                                    <div className='fdr'>
                                                                        <LandrateInput 
                                                                            value={zone.highDemand.offPeak[1]}
                                                                            disabled={isSubmitting || !props.enabled}
                                                                            name={`zones.${index}.highDemand.offPeak[1]`}
                                                                            onChange={handleChange}
                                                                            onBlur={handleBlur} />
                                                                    </div>
                                                                </div>
                                                                <div className='fdc flx1 aic jcc'>
                                                                    <div className='fdr pb10'>
                                                                        <LandrateInput 
                                                                            value={zone.lowDemand.peak[0]}
                                                                            disabled={isSubmitting || !props.enabled}
                                                                            name={`zones.${index}.lowDemand.peak[0]`}
                                                                            onChange={handleChange}
                                                                            onBlur={handleBlur} />
                                                                    </div>
                                                                    <div className='fdr'>
                                                                        <LandrateInput 
                                                                            value={zone.lowDemand.peak[1]}
                                                                            disabled={isSubmitting || !props.enabled}
                                                                            name={`zones.${index}.lowDemand.peak[1]`}
                                                                            onChange={handleChange}
                                                                            onBlur={handleBlur} />
                                                                    </div>
                                                                </div>
                                                                <div className='fdc flx1 aic jcc'>
                                                                    <div className='fdr pb10'>
                                                                        <LandrateInput 
                                                                            value={zone.lowDemand.standard[0]}
                                                                            disabled={isSubmitting || !props.enabled}
                                                                            name={`zones.${index}.lowDemand.standard[0]`}
                                                                            onChange={handleChange}
                                                                            onBlur={handleBlur} />
                                                                    </div>
                                                                    <div className='fdr'>
                                                                        <LandrateInput 
                                                                            value={zone.lowDemand.standard[1]}
                                                                            disabled={isSubmitting || !props.enabled}
                                                                            name={`zones.${index}.lowDemand.standard[1]`}
                                                                            onChange={handleChange}
                                                                            onBlur={handleBlur} />
                                                                    </div>
                                                                </div>
                                                                <div className='fdc flx1 aic jcc'>
                                                                    <div className='fdr pb10'>
                                                                        <LandrateInput 
                                                                            value={zone.lowDemand.offPeak[0]}
                                                                            disabled={isSubmitting || !props.enabled}
                                                                            name={`zones.${index}.lowDemand.offPeak[0]`}
                                                                            onChange={handleChange}
                                                                            onBlur={handleBlur} />
                                                                    </div>
                                                                    <div className='fdr'>
                                                                        <LandrateInput 
                                                                            value={zone.lowDemand.offPeak[1]}
                                                                            disabled={isSubmitting || !props.enabled}
                                                                            name={`zones.${index}.lowDemand.offPeak[1]`}
                                                                            onChange={handleChange}
                                                                            onBlur={handleBlur} />
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className='fdr flx3'>
                                                                <div className='fdr flx1 capacity-column'>
                                                                    <div className='fdc flx1 aic jcc'>
                                                                        <div className='fdr pb10'>
                                                                            <div className='flx1'>
                                                                                <LandrateInput 
                                                                                    value={zone.legacyCharge?.[0] ?? 0}
                                                                                    disabled={isSubmitting || !props.enabled}
                                                                                    name={`zones.${index}.legacyCharge[0]`}
                                                                                    onChange={handleChange}
                                                                                    onBlur={handleBlur}
                                                                                    currencySymbol='R' />
                                                                            </div>
                                                                        </div>
                                                                        <div className='fdr'>
                                                                            <div className='flx1'>
                                                                                <LandrateInput 
                                                                                    value={zone.legacyCharge?.[1] ?? 0}
                                                                                    disabled={isSubmitting || !props.enabled}
                                                                                    name={`zones.${index}.legacyCharge[1]`}
                                                                                    onChange={handleChange}
                                                                                    onBlur={handleBlur}
                                                                                    currencySymbol='R' />
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div className='fdr flx1 capacity-column'>
                                                                    <div className='fdc flx1 aic jcc'>
                                                                        <div className='fdr pb10'>
                                                                            <div className='flx1'>
                                                                                <LandrateInput 
                                                                                    value={zone.generationCapacityCharge?.[0] ?? 0}
                                                                                    disabled={isSubmitting || !props.enabled}
                                                                                    name={`zones.${index}.generationCapacityCharge[0]`}
                                                                                    onChange={handleChange}
                                                                                    onBlur={handleBlur}
                                                                                    currencySymbol='R' />
                                                                            </div>
                                                                        </div>
                                                                        <div className='fdr'>
                                                                            <div className='flx1'>
                                                                                <LandrateInput 
                                                                                    value={zone.generationCapacityCharge?.[1] ?? 0}
                                                                                    disabled={isSubmitting || !props.enabled}
                                                                                    name={`zones.${index}.generationCapacityCharge[1]`}
                                                                                    onChange={handleChange}
                                                                                    onBlur={handleBlur}
                                                                                    currencySymbol='R' />
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div className='fdr flx1 capacity-column'>
                                                                    <div className='fdc flx1 aic jcc'>
                                                                        <div className='fdr pb10'>
                                                                            <div className='flx1'>
                                                                                <LandrateInput 
                                                                                    value={zone.netwrokCapacity[0]}
                                                                                    disabled={isSubmitting || !props.enabled}
                                                                                    name={`zones.${index}.netwrokCapacity[0]`}
                                                                                    onChange={handleChange}
                                                                                    onBlur={handleBlur}
                                                                                    currencySymbol='R' />
                                                                            </div>
                                                                        </div>
                                                                        <div className='fdr'>
                                                                            <div className='flx1'>
                                                                                <LandrateInput 
                                                                                    value={zone.netwrokCapacity[1]}
                                                                                    disabled={isSubmitting || !props.enabled}
                                                                                    name={`zones.${index}.netwrokCapacity[1]`}
                                                                                    onChange={handleChange}
                                                                                    onBlur={handleBlur}
                                                                                    currencySymbol='R' />
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    ))
                                                }
                                            </div>
                                        )
                                    }
                                />
                            </div>
                        </Paper>
                        <div className='fdr ais'>
                            <Paper className='fdc flx1 ais mr10' elevation={3}>
                                <div className='fdr ais'>
                                    <div className='fdc ais flx1 categories'>
                                        <span className='fdr flx1 jcc aic tac'>
                                                Customer Categories
                                        </span>
                                    </div>
                                    <div className='fdc ais flx1 service-charge'>
                                        <span className='fdr flx1 jcc aic tac pl20 pr20'>
                                                Service Charge [R/account/day]
                                        </span>
                                    </div>
                                    <div className='fdc ais flx1 admin-charge'>
                                        <span className='fdr flx1 jcc aic tac pl20 pr20'>
                                                Administration Charge [R/POD/day]
                                        </span>
                                    </div>
                                </div>
                                <div className='fdc ais'>
                                    {
                                        isSubmitting &&
                                            <div className='fdc ais wfill submitting'>
                                                <AbsoluteLinearProgress />
                                            </div>
                                    }
                                    <FieldArray
                                        name='categories'
                                        render={
                                            () => (
                                                <div className='fdc ais'>
                                                    {
                                                        values.categories.map((category, index) => (
                                                            <div className='fdr tariff-row' key={`category_${category.lower}_${category.upper}`}>
                                                                <div className='fdc aic jcc flx1 zone-cell mnh48'>
                                                                    {
                                                                        category.lower > 0 &&
                                                                            <span>&gt; {category.lower > 999 ? `${category.lower / 1000} MVA` : `${category.lower} kVA`} {!category.upper ? '' : ' &'}</span>
                                                                    }
                                                                    {
                                                                        category.upper > 0 &&
                                                                            <span>&le; {category.upper > 999 ? `${category.upper / 1000} MVA` : `${category.upper} kVA`}</span>
                                                                    }
                                                                    {
                                                                        category.lower < 0 &&
                                                                            <span>Key Customers</span>
                                                                    }
                                                                </div>
                                                                <div className='fdr ais flx1 data-columns'>
                                                                    <div className='fdr'>
                                                                        <div className='flx1'/>
                                                                        <div className='flx1'>
                                                                            <LandrateInput 
                                                                                value={category.serviceCharge}
                                                                                disabled={isSubmitting || !props.enabled}
                                                                                name={`categories.${index}.serviceCharge`}
                                                                                onChange={handleChange}
                                                                                onBlur={handleBlur}
                                                                                currencySymbol='R' />
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div className='fdr ais flx1 data-columns'>
                                                                    <div className='fdr'>
                                                                        <div className='flx1'/>
                                                                        <div className='flx1'>
                                                                            <LandrateInput 
                                                                                value={category.administrationCharge}
                                                                                disabled={isSubmitting || !props.enabled}
                                                                                name={`categories.${index}.administrationCharge`}
                                                                                onChange={handleChange}
                                                                                onBlur={handleBlur}
                                                                                currencySymbol='R' />
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        ))
                                                    }
                                                </div>
                                            )
                                        }
                                    />
                                </div>
                            </Paper>
                            <div className='fdc flx1 ais ml10'>
                                <Paper className='fdc ais mb5' elevation={3}>
                                    <div className='fdr ais'>
                                        <div className='fdc ais flx1 categories'>
                                            <span className='fdr flx1 jcc aic tac'>
                                                    Voltage
                                            </span>
                                        </div>
                                        <div className='fdc ais flx1 service-charge'>
                                            <span className='fdr flx1 jcc aic tac pl20 pr20'>
                                                    Ancillary Service Charge [c/kWh]
                                            </span>
                                        </div>
                                        <div className='fdc ais flx1 admin-charge'>
                                            <span className='fdr flx1 jcc aic tac pl20 pr20'>
                                                    Network Demand charge [c/kWh] in all time-of-use periods
                                            </span>
                                        </div>
                                    </div>
                                    <div className='fdc ais'>
                                        {
                                            isSubmitting &&
                                                <div className='fdc ais wfill submitting'>
                                                    <AbsoluteLinearProgress />
                                                </div>
                                        }
                                        <FieldArray
                                            name='voltages'
                                            render={
                                                () => (
                                                    <div className='fdc ais'>
                                                        {
                                                            values.voltages.map((voltage, index) => (
                                                                <div className='fdr tariff-row' key={`voltage_${voltage.lower}_${voltage.upper}`}>
                                                                    <div className='fdc aic jcc flx1 zone-cell mnh48'>
                                                                        {
                                                                            voltage.lower > 0 &&
                                                                                <span>&ge; {voltage.lower > 999 ? `${voltage.lower / 1000} kV` : `${voltage.lower} V`} {!voltage.upper ? '' : ' &'}</span>
                                                                        }
                                                                        {
                                                                            voltage.upper > 0 &&
                                                                                <span>&lt; {voltage.upper > 999 ? `${voltage.upper / 1000} kV` : `${voltage.upper} V`}</span>
                                                                        }
                                                                    </div>
                                                                    <div className='fdr ais flx1 data-columns'>
                                                                        <div className='fdr'>
                                                                            <div className='flx1'/>
                                                                            <div className='flx1'>
                                                                                <LandrateInput 
                                                                                    value={voltage.ancillaryServiceCharge}
                                                                                    disabled={isSubmitting || !props.enabled}
                                                                                    name={`voltages.${index}.ancillaryServiceCharge`}
                                                                                    onChange={handleChange}
                                                                                    onBlur={handleBlur} />
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                    <div className='fdr ais flx1 data-columns'>
                                                                        <div className='fdr'>
                                                                            <div className='flx1'/>
                                                                            <div className='flx1'>
                                                                                <LandrateInput 
                                                                                    value={voltage.networkDemandCharge}
                                                                                    disabled={isSubmitting || !props.enabled}
                                                                                    name={`voltages.${index}.networkDemandCharge`}
                                                                                    onChange={handleChange}
                                                                                    onBlur={handleBlur} />
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            ))
                                                        }
                                                    </div>
                                                )
                                            }
                                        />
                                    </div>
                                </Paper>
                                <Paper className='fdc flx1 ais mt5' elevation={3}>
                                    <div className='fdc ais reactive-energy-charge'>
                                        <span className='fdr flx1 jcc aic tac'>
                                                Reactive Energy Charge [c/kVArh]
                                        </span>
                                    </div>
                                    <div className='fdr ais'>
                                        <div className='fdr flx1 ais jcc reactive-energy-high-season'>
                                            <span className='fdr flx1 jcc aic pl10'>
                                                    High Season
                                            </span>
                                        </div>
                                        <div className='fdr flx1 ais jcc reactive-energy-low-season'>
                                            <span className='fdr flx1 jcc aic pl10'>
                                                    Low Season
                                            </span>
                                        </div>
                                    </div>
                                    <div className='fdr tariff-row ais flx1 data-columns'>
                                        <div className='fdr flx1 jcc aic'>
                                            <LandrateInput 
                                                value={values.reactiveEnergyCharge.high}
                                                disabled={isSubmitting || !props.enabled}
                                                name={'reactiveEnergyCharge.high'}
                                                onChange={handleChange}
                                                onBlur={handleBlur} />
                                        </div>
                                        <div className='fdr flx1 jcc aic'>
                                            <LandrateInput 
                                                value={values.reactiveEnergyCharge.low}
                                                disabled={isSubmitting || !props.enabled}
                                                name={'reactiveEnergyCharge.low'}
                                                onChange={handleChange}
                                                onBlur={handleBlur} />
                                        </div>
                                    </div>
                                </Paper>
                            </div>
                        </div>
                        <div className='fdr flx1 jcfe aife mt15'>
                            <OutlinedStadiumButton className='mr16' variant='text' type='reset' disabled={isSubmitting || !props.enabled}>
                                        CANCEL
                            </OutlinedStadiumButton>
                            <StadiumButton type='submit' disabled={isSubmitting || !props.enabled}>
                                        SAVE
                            </StadiumButton>
                        </div>
                    </form>
                )}
            </Formik>
        </div>
    );
};

const mapStateToProps = (state : IRootState) => {
    return {
        auth: state.auth,
    };
};

export default connect(
    mapStateToProps,
)(LPUEdit);
